import { z } from 'zod';

export const WeekDayHappyHourDefinition = z.object({
  shelfTitle: z.string(),
  banner: z.string(),
  popup: z.object({
    foreground: z.string(),
    background: z.string(),
    buttonText: z.string(),
  }),
  notification: z.object({
    title: z.string(),
    body: z.string(),
  }),
  skipButtonStickerText: z.string(),
  booksByDay: z.object({
    sun: z.array(z.string()),
    mon: z.array(z.string()),
    tue: z.array(z.string()),
    wed: z.array(z.string()),
    thu: z.array(z.string()),
    fri: z.array(z.string()),
    sat: z.array(z.string()),
  }),
  discount: z.number().min(0).max(90),
  localTimeWindow: z.object({
    from: z.number().min(0).max(2359),
    to: z.number().min(0).max(2359),
  }),
});
export type WeekDayHappyHourDefinition = z.infer<typeof WeekDayHappyHourDefinition>;
